import Vue from 'vue'

export const setDestinyAccounts = (state, {destinyAccounts}) => {
  state.destinyAccounts = destinyAccounts
}

export const selectCharacter = (state, {characterId}) => {
  state.selectedCharacter = characterId
}

export const clearFetchedData = state => {
  state.currentUser = null
  state.destinyAccounts = null
  state.currentDestinyMembership = null
  state.destinyMemberships = null
  state.characters = null
  state.selectedCharacter = null
  state.items = null
  state.filter = {
    search: ''
  }
}

export const setItems = (state, {items}) => {
  state.items = items
}

export const updateItemCharacterIndex = (state, {item, newCharacterIndex}) => {
  state.items.find((searched) => searched.data.itemId === item.data.itemId).data.characterIndex = newCharacterIndex
}

export const lockItem = (state, {item}) => {
  state.items.find((searched) => searched.data.itemId === item.data.itemId).data.state = 1
}

export const unLockItem = (state, {item}) => {
  state.items.find((searched) => searched.data.itemId === item.data.itemId).data.state = 0
}

export const setEquipped = (state, {item}) => {
  state.items.find((searched) => searched.data.itemId === item.data.itemId).data.transferStatus = 1
}

export const setUnequipped = (state, {item}) => {
  state.items.find((searched) => searched.data.itemId === item.data.itemId).data.transferStatus = 0
}

export const favoriteItem = (state, {item}) => {
  state.favorites = state.favorites.filter(i => i !== item.key).concat([item.key])
  localStorage.setItem('favorites', JSON.stringify(state.favorites))
}

export const unFavoriteItem = (state, {item}) => {
  state.favorites = state.favorites.filter(i => i !== item.key)
  localStorage.setItem('favorites', JSON.stringify(state.favorites))
}
export const setFavorities = (state, {favorities}) => {
  state.favorites = favorities
  localStorage.setItem('favorites', JSON.stringify(state.favorites))
}

export const updateTagsDefinitions = (state, {tagsDefinitions}) => {
  state.tagsDefinitions = tagsDefinitions
  localStorage.setItem('tagsDefinitions', JSON.stringify(state.tagsDefinitions))
}

export const setTagDefinition = (state, {tag, color}) => {
  Vue.set(state.tagsDefinitions, tag, {'color': color})
  localStorage.setItem('tagsDefinitions', JSON.stringify(state.tagsDefinitions))
}

export const deleteTagDefinition = (state, tag) => {
  state.tagsDefinitions = Object.entries(state.tagsDefinitions)
    .filter(([needle, _]) => needle !== tag)
    .reduce((acc, [tag, definition]) => {
      acc[tag] = definition
      return acc
    }, {})
  localStorage.setItem('tagsDefinitions', JSON.stringify(state.tagsDefinitions))
}

export const toggleTag = (state, {item, tag}) => {
  const current = new Set(state.tags[tag] || [])
  if (current.has(item.key)) {
    current.delete(item.key)
  } else {
    current.add(item.key)
  }
  const obj = []
  obj[tag] = [...current]
  state.tags = Object.assign(state.tags, obj)
  localStorage.setItem('tags', JSON.stringify(state.tags))
}

export const updateTags = (state, {tags}) => {
  state.tags = tags
  localStorage.setItem('tags', JSON.stringify(state.tags))
}



// WEBPACK FOOTER //
// ./src/store/mutations.js